import { Button, Flex, Grid } from "@chakra-ui/react"
import { IterationStatusBadge } from "component/mapping/iteration/IterationStatusBadge"
import { MetadatasParamsRow } from "component/mapping/iteration/metadatas/MetadatasParamsRow"
import { PageHeading } from "component/page/PageHeading"
import { FC } from "react"
import { FaExternalLinkAlt } from "react-icons/fa"
import { SmrMetadatas } from "type/mapping/iterationMetadatas"

interface SMRMetadatasParamsProps {
  status?: string
  metadatas?: SmrMetadatas
}

// BI шлёт в smr_name имя файла сметы: "1_12_Ген_подряд_ЖД3_..._К_ДОГОВОРУ.xml".
// Показываем без расширения и с пробелами вместо "_"
export const formatSmrName = (name?: string) =>
  name
    ?.replace(/\.xml$/i, "")
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim()

// Шапка проверки сметы: вместо "УПД № … от …" — название сметы и объект (KRE-713)
export const SMRMetadatasParams: FC<SMRMetadatasParamsProps> = (props) => {
  const { status, metadatas } = props

  const smrDetails = metadatas?.input_message?.smr_details

  return (
    <Flex w="full" direction="column" gap={5}>
      <PageHeading>
        <Flex w="full" direction="column" gap={2}>
          {/* Building Name */}
          <Flex w="full" direction="row" alignItems="center" gap={5}>
            {smrDetails?.building_name}
          </Flex>

          {/* SMR Name & Status */}
          <Flex w="full" direction="row" alignItems="center" gap={3}>
            <Flex w="full" direction="row" alignItems="center" gap={3}>
              {formatSmrName(smrDetails?.smr_name) || "Смета"}
            </Flex>
            <IterationStatusBadge size="xl" status={status} />
          </Flex>
        </Flex>
      </PageHeading>

      <Grid
        w="fit-content"
        templateColumns="repeat(2, auto)"
        rowGap={3}
        columnGap={5}
        px={2}
      >
        {/* Счётчики модели (сколько групп нашлось, сколько позиций пропустили)
            сметчику не нужны — как и у УПД, здесь только данные документа.
            Появятся у сметы новые поля в smr_details — добавляем сюда */}
        {smrDetails?.smr_link && (
          <MetadatasParamsRow
            name="Смета в BI"
            value={
              <a href={smrDetails.smr_link} target="_blank" rel="noopener noreferrer">
                <Button size="sm" rightIcon={<FaExternalLinkAlt color="gray" />}>
                  Открыть смету
                </Button>
              </a>
            }
          />
        )}
      </Grid>
    </Flex>
  )
}
